import { Platform } from "react-native";
import * as Application from "expo-application";
import * as DataWedgeApi from "@/modules/datawedge-api";
import * as Sentry from "@sentry/react-native";
import {
  GetConfigResult,
  isIntentPlugin,
  isKeystrokePlugin,
} from "@/modules/datawedge-api/src/DataWedgeApi.types";

export async function installDataWedgeProfile() {
  if (Platform.OS !== "android") return;

  const applicationId =
    Application.applicationId ?? "com.barkh.storesprint.main";

  try {
    const profiles = await DataWedgeApi.getProfilesList();

    if (profiles === null) {
      return;
    }

    const result = await DataWedgeApi.setConfig({
      profileName: "storesprint",
      configMode: profiles?.find((profile) => profile === "storesprint")
        ? "OVERWRITE"
        : "CREATE_IF_NOT_EXIST",
      profileEnabled: true,
      appList: [
        {
          packageName: applicationId,
          activityList: [`${applicationId}.MainActivity`],
        },
      ],
      pluginConfig: [
        {
          name: "KEYSTROKE",
          paramList: {
            outputEnabled: false,
          },
        },
        {
          name: "INTENT",
          paramList: {
            outputEnabled: true,
            intentAction: "android.intent.action.storesprint.BARCODE_SCAN",
            intentCategory: "android.intent.category.DEFAULT",
            intentDelivery: "start_activity",
          },
        },
      ],
    });

    if (result.RESULT !== "SUCCESS") {
      Sentry.captureMessage(
        `Failed to set datawedge config: ${JSON.stringify(result)}`
      );
    }

    const activeProfile = await DataWedgeApi.getActiveProfile();
    if (activeProfile !== "storesprint") {
      Sentry.captureMessage(
        `Wrong DataWedge profile is active: ${JSON.stringify(activeProfile)}`,
        "error"
      );
    }

    const profile = await DataWedgeApi.getConfig("storesprint");
    if (!profile || !isProfileValid(profile)) {
      Sentry.captureMessage("Installed DataWedge profile is invalid", {
        level: "error",
        extra: profile ?? undefined,
      });
    }
  } catch (e) {
    Sentry.captureException(e);
  }
}

function isProfileValid(profile: GetConfigResult): boolean {
  return (
    profile.PROFILE_ENABLED === "true" &&
    profile.PROFILE_NAME === "storesprint" &&
    !!profile.APP_LIST.find(
      (app) =>
        app.ACTIVITY_LIST.find(
          (activity) => activity === `${Application.applicationId}.MainActivity`
        ) && app.PACKAGE_NAME === Application.applicationId!
    ) &&
    !!profile.PLUGIN_CONFIG.find(
      (plugin) =>
        isIntentPlugin(plugin) &&
        plugin.PARAM_LIST.intent_output_enabled === "true" &&
        plugin.PARAM_LIST.intent_action ===
          "android.intent.action.storesprint.BARCODE_SCAN" &&
        plugin.PARAM_LIST.intent_category ===
          "android.intent.category.DEFAULT" &&
        plugin.PARAM_LIST.intent_delivery === "0" &&
        plugin.PARAM_LIST.intent_use_content_provider !== "true"
    ) &&
    !profile.PLUGIN_CONFIG.find(
      (plugin) =>
        isKeystrokePlugin(plugin) &&
        plugin.PARAM_LIST.keystroke_output_enabled === "true"
    )
  );
}
